<div class="padding">
  <h1 class="left-box">{{ 'common.labels.users' | transloco }}</h1>

  <mat-card>
    <mat-card-content>
      <!-- Container div for everything -->
      @if (repo.resource$ | async; as data) {
        <div>
          <app-search-users-filter></app-search-users-filter>
          <div class="spacer-small"></div>
          <!-- Main orders table -->
          @if (data) {
            <div class="table-container">
              <!-- Conditional paginator at the top (show only when number of orders displayed is >= 50) -->
              @if (data.length >= 50) {
                <div>
                  <mat-paginator [pageSize]="this.repo.pageSize$ | async"
                    [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
                    [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
                  (page)="page($event)"></mat-paginator>
                  <div class="spacer-small"></div>
                </div>
              }
              <!-- End of conditional paginator at the top -->
              <!-- Orders table -->
              @if (data.length > 0) {
                <table mat-table matSort [dataSource]="data" multiTemplateDataRows class="mat-elevation-z0"
                  (matSortChange)="sort($event)">
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header id="Name"> {{ 'common.labels.name' | transloco }}
                    </th>
                    <td mat-cell *matCellDef="let user"> {{formatName(user)}} </td>
                  </ng-container>
                  <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header id="username"> {{ 'common.labels.username' | transloco }}
                    </th>
                    <td mat-cell *matCellDef="let user"> {{user.userName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header id="email"> {{ 'common.labels.email' | transloco }}
                    </th>
                    <td mat-cell *matCellDef="let user"> {{user.contactDetails?.email}} </td>
                  </ng-container>
                  <ng-container matColumnDef="userGroupName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header id="userGroupName"> {{ 'common.labels.userGroup' | transloco }}
                    </th>
                    <td mat-cell *matCellDef="let user"> {{user.userGroupName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header id="status"> {{ 'common.labels.status' | transloco }}
                    </th>
                    <td mat-cell *matCellDef="let user"> {{getUserStatus(user)}} </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['userGroups', row.userGroupID, 'users', row.id]"></tr>
                </table>
              }
              <!-- End of orders table-->
              <!-- Message while loading (show only if data.length is 0 and loading) -->
              @if (((this.repo.loading$ | async) ?? false) && data.length === 0) {
                <div class="padding center padding-top-bottom-50"
                  >
                  &nbsp;
                </div>
              }
              <!-- Paginator for the bottom -->
              <div class="spacer-small"></div>
              @if (data.length > 0) {
                <mat-paginator [pageSize]="this.repo.pageSize$ | async"
                  [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
                  [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
                (page)="page($event)"></mat-paginator>
              }
              <!-- End of paginator for the bottom -->
            </div>
          }
          <!-- End of main orders table-->
          <!-- Spinner (shows over entire card) -->
          @if (repo.loading$ | async) {
            <div class="loading-spinner-overlay">
              <mat-spinner></mat-spinner>
            </div>
          }
          <!-- End of spinner -->
          <lib-list-issue [repo]="this.repo" [data]="data"></lib-list-issue>
        </div>
      }
      <!-- End of container div for everything -->
    </mat-card-content>
  </mat-card>
</div>